import $ from "/js/libs/jquery-3.3.1.min.js"

export class Simulator {

  constructor(tagDropCallback, tagRemoveCallback) {
    this.el = $(".simulator");

    this.fields = [
      {"name": "LANGUAGE", "elementId": "language"},
      {"name": "AGE", "elementId": "age"},
      {"name": "WALLPAPER", "elementId": "wallpaper"},
      {"name": "EMOTION", "elementId": "emotion"},
      {"name": "ST_INTRODUCTION", "elementId": "register-progress"},
      {"name": "ST_DISCOVERY_01", "elementId": "discovery1-progress"},
      {"name": "ST_DISCOVERY_02", "elementId": "discovery2-progress"},
      {"name": "ST_DISCOVERY_03", "elementId": "discovery3-progress"},
      {"name": "ST_DISCOVERY_04", "elementId": "discovery4-progress"},
      {"name": "ST_LOGBOOK_01", "elementId": "logbook1-progress"},
      {"name": "ST_LOGBOOK_02", "elementId": "logbook2-progress"},
      {"name": "ST_LOGBOOK_03", "elementId": "logbook3-progress"},
      {"name": "ST_LOGBOOK_04", "elementId": "logbook4-progress"},
      {"name": "ST_OUTRO", "elementId": "outro-progress"},
    ]

    // Keep RFIDs data from after a page refresh
    $("input, select", this.el).change(() => {
      this.saveToLocalStorage();
    });
    this.loadFromLocalStorage();

    // Allow to toggle simulator visibility using toggle button
    $(".simulator-toggle-collapse", this.el).click(() => {
      this.toggle();
    });

    // On tag drop button
    $("#simulator-btn-tag-drop button", this.el).on("click", (e) => {
      e.preventDefault();
      const visitorData = this.buildMessageFromInputs();
      visitorData[0]["tag"] = "TD"
      tagDropCallback(visitorData);
    });

    // On tag remove button
    $("#simulator-btn-tag-remove button", this.el).on("click", (e) => {
      e.preventDefault();
      const visitorData = this.buildMessageFromInputs();
      visitorData[0]["tag"] = "TR"
      tagRemoveCallback(visitorData);
    });

    // Reset tag
    $("#simulator-btn-tag-reset button", this.el).on("click", (e) => {
      e.preventDefault();
      for (let i = 0; i < this.fields.length; i++) {
        const $el = $(`[name='simulator-${this.fields[i].elementId}']`);
        const options = $.map($el.find('option'), function (e) {
          return e.value;
        });
        $el.val(options[0]);
      }
      this.saveToLocalStorage()
    });

    $(document).keydown((e) => {
      if (e.keyCode === 38) {
        // UP
        const visitorData = this.buildMessageFromInputs();
        visitorData[0]["tag"] = "TR"
        tagRemoveCallback(visitorData);
      } else if (e.keyCode === 40) {
        // DOWN
        const visitorData = this.buildMessageFromInputs();
        visitorData[0]["tag"] = "TD"
        tagDropCallback(visitorData);
      }
    });

  }

  toggle() {
    (this.el.hasClass("collapsed")) ? this.expand() : this.collapse();
  }

  expand() {
    this.el.removeClass("collapsed");
  }

  collapse() {
    this.el.addClass("collapsed");
  }

  saveToLocalStorage() {
    const formData = JSON.stringify($("form", this.el).serializeArray());
    localStorage.setItem("simulatorData", formData);
  }

  loadFromLocalStorage() {
    const formData = JSON.parse(localStorage.getItem("simulatorData"));
    if (Array.isArray(formData)) {
      formData.forEach((values) => {
        $(`[name='${values.name}']`, this.el).val(values.value);
      })
    }
  }

  loadFromMessage(message) {
    // Build fields values
    for (let i = 0; i < this.fields.length; i++) {
      $(`[name='simulator-${this.fields[i].elementId}']`).val(message.records[this.fields[i].name]);
    }
  }

  buildMessageFromInputs() {
    const progressValue = (name) => {
      return $(`[name='simulator-${name}']`, this.el).val()?.toString().toUpperCase()
    }

    const jsonData = [{
      "station": "05b", // Station number
      "antenna": "01", // antenna number
      "records": {
        "UPDATED_TIMESTAMP": "12-20-2023 18:13:27",
        "UUID": "0468DE30B62A81",
      }
    }];

    // Build fields values
    for (let i = 0; i < this.fields.length; i++) {
      jsonData[0].records[this.fields[i].name] = progressValue(this.fields[i].elementId)
    }

    return jsonData;
  }
}
